import { Alert, CircularProgress, Stack } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { ProjectException } from '../../../project-exceptions/models/ProjectException';
import { ObjectDataViewer } from '../../components/ObjectDataViewer';
import { CallDetail } from '../models/CallDetail';
import { StackTraceTable } from './StackTraceTable';

type Props = {
  onInit: () => Promise<CallDetail | null>;
  onCreateException?: (term: string) => Promise<ProjectException | null>;
};

export const CallDetails = ({ onInit, onCreateException }: Props) => {
  const [callDetails, setCallDetails] = useState<CallDetail | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const load = async () => {
      const details = await onInit();
      setCallDetails(details);
      setIsLoaded(true);
    };
    if (!isLoaded) {
      load();
    }
  }, [isLoaded, onInit]);

  if (!callDetails && isLoaded) {
    return <Alert severity="error">{t('somethingWentWrong')}</Alert>;
  }

  if (!callDetails) {
    return (
      <Stack sx={{ p: 2, alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Stack>
    );
  }

  const args = callDetails.getArguments();
  const stackTrace = callDetails.getStackTrace();

  return (
    <Stack data-role="call-details" spacing={2} sx={{ '& .json-viewer': { backgroundColor: 'white' } }}>
      {args && <ObjectDataViewer value={args} loading={false} />}
      {stackTrace?.length ? (
        <StackTraceTable title={t('stackframes')} initialFrames={stackTrace} parentLoading={false} onCreateException={onCreateException} />
      ) : (
        <Alert color="info">{t('noStackTraceToShow')}</Alert>
      )}
    </Stack>
  );
};
